import { render, staticRenderFns } from "./BX.vue?vue&type=template&id=5486ec65"
import script from "./BX.vue?vue&type=script&lang=js"
export * from "./BX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports